export default __webpack_public_path__ + "static/media/ic-left-arrow.37d2f5b9.svg";